import { render, staticRenderFns } from "./app-order-detail.vue?vue&type=template&id=7985abf6&scoped=true&"
import script from "./app-order-detail.vue?vue&type=script&lang=js&"
export * from "./app-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7985abf6",
  null
  
)

export default component.exports